import * as THREE from 'three'
import { mergeVertices } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

export default function createWobbleIco({ scene, wobble })
{
  let geometry = new THREE.IcosahedronGeometry(2.5, 50)
  geometry = mergeVertices(geometry)
  geometry.computeTangents()

  const mesh = new THREE.Mesh(geometry, wobble.material)
  mesh.customDepthMaterial = wobble.depthMaterial
  mesh.castShadow = true
  mesh.receiveShadow = true

  scene.add(mesh)

  return mesh
}
